import React from 'react';
import { DropdownItem, PlusIcon } from 'ui-components';

interface AddToListDropdownItemProps {
  onClick: () => void;
}

//Copied from components/TalentDropdownMenu
export function AddToListDropdownItem({ onClick }: AddToListDropdownItemProps) {
  return (
    <DropdownItem onClick={onClick} trackId="wm-add-single-talent-to-list">
      <PlusIcon boxSize={4} />
      Add to a List
    </DropdownItem>
  );
}
